var _circle, _path, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.57,
    cy: 32.32,
    r: 15,
    fill: "#9BAEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.11 35.665a5.64 5.64 0 01-7.08 0 1.502 1.502 0 10-1.92 2.31 8.52 8.52 0 0010.92 0 1.502 1.502 0 10-1.92-2.31zm-7.725-5.535a1.5 1.5 0 002.115 0 1.5 1.5 0 000-2.115 4.62 4.62 0 00-6.36 0 1.502 1.502 0 00.429 2.536 1.5 1.5 0 001.686-.42 1.5 1.5 0 012.13 0zm4.185-12.81a15 15 0 100 29.999 15 15 0 000-29.999zm0 27a12 12 0 110-24 12 12 0 010 24z",
    fill: "#4A62BA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.453,
    cy: 26.352,
    r: 18.906,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.982,
    cy: 26.822,
    r: 13.646,
    fill: "#D8E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.625 30.259a5.797 5.797 0 01-7.276 0 1.544 1.544 0 00-1.974 2.374 8.757 8.757 0 0011.224 0 1.544 1.544 0 10-1.974-2.374zm-7.94-5.689a1.542 1.542 0 002.175 0 1.542 1.542 0 000-2.174 4.748 4.748 0 00-6.537 0 1.543 1.543 0 102.174 2.174 1.54 1.54 0 012.189 0zm12.966-2.174a4.748 4.748 0 00-6.537 0 1.541 1.541 0 002.174 2.174 1.542 1.542 0 012.19 0 1.542 1.542 0 002.173 0 1.542 1.542 0 000-2.174zm-8.664-10.992a15.417 15.417 0 100 30.834 15.417 15.417 0 000-30.834zm0 27.75a12.333 12.333 0 110-24.666 12.333 12.333 0 010 24.666z",
    fill: "#2F4491"
  })));
}
export default __webpack_public_path__ + "media/homeProperty/happy-4ddf24b7.svg";
export { SvgHappy as ReactComponent };